<template>
    <div id="vue-social" class="c-article__share-mobile">
        <div class="c-article__share-wrap" :data-did="dId">
            <div class="c-card-message right" :class="{show: showMessage}" :style="{bottom: 'auto', top: msgY}">
                <img src="/img/ui/cancel.svg" alt="close" @click="close" />
                <div>
                    <h5>{{ message.title }}</h5>
                </div>
                <p v-html="message.content"></p>
                <p v-if="message.showLink"><a @click="like(true)">{{ message.linkText }}</a></p>
            </div>
            <div class="c-article__action c-article__action--like" @click="like(false)" :class="{ liked : postLiked }">
                <svg width="43px" height="40px" viewBox="0 0 43 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g class="c-article__like-fill" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g class="c-article__like-stroke" stroke="#979797">
                            <path d="M42,12.9605141 C42,6.0797209 36.3713695,0.5 29.4258792,0.5 C26.5279162,0.5 23.7816522,1.47909502 21.5613783,3.24630218 L21.25,3.49414099 L20.9386217,3.24630218 C18.7183478,1.47909502 15.9720838,0.5 13.0741208,0.5 C6.1286305,0.5 0.5,6.0797209 0.5,12.9605141 C0.5,16.1169263 1.69864044,19.0868885 3.834024,21.3907467 L18.4318094,38.2501716 C18.5141517,38.3563847 18.5954766,38.4505531 18.6758468,38.5323383 C19.293754,39.152456 20.1091286,39.5 20.985346,39.5 C21.8584266,39.5 22.6749266,39.1545651 23.2679802,38.5603564 C23.3841514,38.4378328 23.4400403,38.3760733 23.5052066,38.297365 L38.6945486,21.3797366 C40.8054652,19.0825577 42,16.1110947 42,12.9605141 Z" id="Mask"></path>
                        </g>
                    </g>
                </svg>
                <span v-if="postLikes === 1">{{ postLikes }} Like</span>
                <span v-else>{{ postLikes }} Likes</span>
            </div>
            <div class="c-article__action c-article__action--repost" @click="repost" :class="{ reposted : reposted }">
                <svg width="60px" height="40px" viewBox="0 0 60 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g stroke="#979797">
                            <path class="c-article__repost-red" d="M58.2838788,39.1031606 C57.9370184,38.617763 57.5934384,38.0374372 57.2725451,37.3592736 C56.4741641,35.6720065 55.9337486,33.6362027 55.7660616,31.2370752 L55.7536414,31.0593763 L55.8563739,30.9138526 C58.1399678,27.6790729 59.3864885,23.8098819 59.3864885,19.7500006 C59.3864885,9.11742432 50.8533811,0.5 40.3297311,0.5 C29.8060811,0.5 21.2729737,9.11742432 21.2729737,19.7500006 C21.2729737,30.382577 29.8060811,39.0000013 40.3297311,39.0000013 C43.5976622,39.0000013 46.7451781,38.1685336 49.5415664,36.6057037 L49.8463883,36.4353465 L50.1112824,36.6628746 C52.3742802,38.6066534 55.0879373,39.4199736 58.2838788,39.1031606 Z" id="Combined-Shape"></path>
                            <path class="c-article__repost-blue" d="M37.5109052,39.1031606 C37.1640447,38.617763 36.8204648,38.0374372 36.4995714,37.3592736 C35.7011905,35.6720065 35.160775,33.6362027 34.993088,31.2370752 L34.9806677,31.0593763 L35.0834003,30.9138526 C37.3669941,27.6790729 38.6135149,23.8098819 38.6135149,19.7500006 C38.6135149,9.11742432 30.0804074,0.5 19.5567574,0.5 C9.03310743,0.5 0.5,9.11742432 0.5,19.7500006 C0.5,30.382577 9.03310743,39.0000013 19.5567574,39.0000013 C22.8246885,39.0000013 25.9722045,38.1685336 28.7685928,36.6057037 L29.0734146,36.4353465 L29.3383088,36.6628746 C31.6013066,38.6066534 34.3149637,39.4199736 37.5109052,39.1031606 Z" id="Combined-Shape" transform="translate(19.556757, 19.834827) scale(-1, 1) translate(-19.556757, -19.834827) "></path>
                        </g>
                    </g>
                </svg>
                <span v-if="reposts === 1">{{ reposts }} Repost</span>
                <span v-else>{{ reposts }} Reposts</span>
            </div>
            <div class="c-article__action c-article__action--comment" @click="comment" :class="{ commented : commented }">
                <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g stroke="#979797">
                            <path class="c-article__comment-fill" d="M37.5061525,39.4325063 C37.1576583,38.9417122 36.8123724,38.3542391 36.4900002,37.6671118 C35.692169,35.9665572 35.1521251,33.9147196 34.9845478,31.496615 L34.9723222,31.3202022 L35.0737262,31.1753294 C37.3574407,27.9126567 38.6041258,24.009794 38.6041258,19.9144676 C38.6041258,9.1901187 30.0721504,0.5 19.5520629,0.5 C9.03197539,0.5 0.5,9.1901187 0.5,19.9144676 C0.5,30.6388165 9.03197539,39.3289352 19.5520629,39.3289352 C22.8185197,39.3289352 25.9646844,38.4907022 28.7600405,36.9150614 L29.0667944,36.7421554 L29.3329423,36.9727194 C31.5962672,38.9334389 34.309916,39.753131 37.5061525,39.4325063 Z" id="Combined-Shape"></path>
                            <ellipse class="c-article__comment-ellipsis" id="Path" cx="12.0588235" cy="20" rx="1.91176471" ry="2"></ellipse>
                            <ellipse class="c-article__comment-ellipsis" id="Path" cx="19.2941176" cy="20" rx="1.91176471" ry="2"></ellipse>
                            <ellipse class="c-article__comment-ellipsis" id="Path" cx="26.5294118" cy="20" rx="1.91176471" ry="2"></ellipse>
                        </g>
                    </g>
                </svg>
                <span v-if="commentsCount === 1">{{ commentsCount }} Comment</span>
                <span v-else>{{ commentsCount }} Comments</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dId: this.$root.dyadey_id,
            isMember: this.$root.is_member,
            msgY: '-164px',
            message: this.$simpleStore.message,
            postLiked: this.$root.liked,
            postLikes: this.$root.likes,
            commented: this.$root.commented,
            reposts: this.$root.reposts,
            reposted: this.$root.reposted,
            commentsCount: this.$root.comments.length,
            stats: this.$simpleStore.stats,
            showMessage: false
        }
    },
    created() {
        this.$root.$on('update-icon-comment-count', (data) => {
            this.commentsCount = this.$root.comments.length;
        });
    },
    methods: {
        close() {
            this.showMessage = false;
        },
        like(confirmed) {
            if (this.$root.user !== false) {
                this.$simpleStore.like(this, confirmed);
            } else {
                this.$simpleStore.showMemberPanel(this);
            }
        },
        repost() {

        },
        comment() {

        }
    }
}
</script>
